module.exports = __webpack_public_path__ + "img/home.28f7e9b8.jpg";